export default {
  allCompanyAdminPermissions: [
    { id: 'manage_workflows', name: 'Manage Workflows', description: 'Allows the user to add, edit and remove workflows, and assign them to teams' },
    { id: 'manage_admins', name: 'Manage Admins', description: "Allows the user to edit other users' company admin permissions." },
    { id: 'add_teams', name: 'Add Teams', description: 'Allows the user to add teams.' },
    { id: 'edit_teams', name: 'Edit/Remove Teams', description: 'Allows the user to edit and remove teams, and add and remove users from teams.' },
    { id: 'manage_company', name: 'Manage Company Settings', description: "Allows the user to edit your company's Vos Voco settings." },
    { id: 'view_log', name: 'View Admin Log', description: 'Allows the user to see the log of previous admin activity.' }
  ],
  defaultCompanyAdminPermissions: [
    { id: 'manage_admins', name: 'Manage Admins', description: "Allows the user to edit other users' company admin permissions." },
    { id: 'add_teams', name: 'Add Teams', description: 'Allows the user to add teams.' },
    { id: 'edit_teams', name: 'Edit/Remove Teams', description: 'Allows the user to edit and remove teams, and add and remove users from teams.' },
    { id: 'manage_company', name: 'Manage Company Settings', description: "Allows the user to edit your company's Vos Voco settings." },
    { id: 'view_log', name: 'View Admin Log', description: 'Allows the user to see the log of previous admin activity.' }
  ],
  teamAdminPermissions: [
    { id: 'run_reports', name: 'Run Reports', description: 'Allows the user to run reports and analytics on events involving this team.' },
    { id: 'add_users', name: 'Add Users', description: 'Allows the user to add other users to this team.' },
    { id: 'edit_users', name: 'Edit/Remove Users', description: 'Allows the user to edit users and user permissions, and remove users from this team.' },
    { id: 'edit_events', name: 'Edit Events', description: 'Allows the user to edit events involving this team.' },
    { id: 'print_qr_codes', name: 'Print QR Codes', description: 'Allows the user to print QR codes with this team as the originator.' }
  ],
  teamMemberPermissions: [
    { id: 'run_reports', name: 'Run Reports', description: 'Allows the user to run reports and analytics on events involving this team.' },
    { id: 'print_qr_codes', name: 'Print QR Codes', description: 'Allows the user to print QR codes with this team as the originator.' },
    { id: 'view_inbox', name: 'View Inbox', description: "Allows the user to view events in this team's inbox." },
    { id: 'view_case_history_self', name: 'View Case History (Own Events)', description: "Allows the user to view events in the team's case history that they created." },
    { id: 'view_case_history_others', name: 'View Case History (Other Events)', description: "Allows the user to view events in the team's case history that other users created." },
    { id: 'respond_to_events', name: 'Respond to Events', description: "Allows the user to respond to eents in this team's inbox." },
    { id: 'close_events', name: 'Close Events', description: 'Allows the user to close and/or add root causes to this events assigned to this team.' },
    { id: 'manage_notifications', name: 'Manage Notifications', description: 'Allows the user to choose which email notifications they receive for this team.' }
  ],
  emailNotifications: [
    { id: 'email_when_action_required', name: 'Action Required', description: 'Receive an email when action is required from this team regarding a case.' },
    { id: 'email_when_updated', name: 'Case Updated', description: 'Receive an email when a case this team is involved with has been updated in any way.' },
    { id: 'email_when_event_raised', name: 'Case Raised', description: 'Receive an email when a member of this team has raised a new case.' },
    { id: 'email_when_resolved', name: 'Case Resolved', description: 'Receive an email when a case this team is involved with has been resolved (but not necessarily closed.)' },
    { id: 'email_when_closed', name: 'Case Closed', description: 'Receive an email when a case this team is involved with has closed.' }
  ],
  companyAdminPermissions (company) {
    return company.available_admin_permissions.map((identifier) => {
      return this.allCompanyAdminPermissions.find((p) => { return p.id === identifier })
    }).filter((permission) => permission != null)
  },
  isServiceWideAdmin (user) {
    return user.is_service_wide_admin
  },
  isAdmin (user) {
    return user.team_users.find((tu) => tu.is_admin) != null ||
      user.company_users.find((cu) => cu.is_admin) != null
  },
  canManageWorkflows (user) {
    return user.company_users.find((cu) => cu.permissions.indexOf('manage_workflows') !== -1)
  },
  canEditWorkflow (user, workflow, company) {
    return workflow.can_edit && user.company_users.find((cu) => cu.company.id === company.id && cu.permissions.indexOf('manage_workflows') !== -1) != null
  },
  canViewCompanyAdmins (user) {
    return user.company_users.find((cu) => cu.is_admin) != null
  },
  canManageCompanyAdmins (user, company) {
    return user.company_users.find((cu) => cu.company.id === company.id && cu.permissions.indexOf('manage_admins') !== -1) != null
  },
  canViewAdminLog (user) {
    return user.company_users.find((cu) => cu.permissions.indexOf('view_log') !== -1)
  },
  canViewTeams (user) {
    return user.company_users.find((cu) => cu.is_admin) != null
  },
  canAddTeam (user, company) {
    return user.company_users.find((cu) => cu.company.id === company.id && cu.permissions.indexOf('add_teams') !== -1) != null
  },
  canViewTeamAdmins (user) {
    return user.company_users.find((cu) => cu.is_admin) != null ||
      user.team_users.find((tu) => tu.is_admin) != null
  },
  canManageTeamAdmins (user, company, team) {
    return user.company_users.find((cu) => cu.company.id === company.id && cu.permissions.indexOf('edit_teams') !== -1) != null
  },
  canManageTeamMembers (user, company, team) {
    if (this.canManageTeamAdmins(user, company, team)) {
      return true
    }
    return user.team_users.find((tu) => tu.team.id === team.id && tu.permissions.indexOf('edit_users') !== -1) != null
  },
  canViewTeamMembers (user) {
    return user.team_users.find((tu) => tu.is_admin) != null
  },
  canManageTeam (user, company, team) {
    return user.company_users.find((cu) => cu.company.id === company.id && cu.permissions.indexOf('edit_teams') !== -1) != null
  },
  canPrint (user) {
    return user.team_users.find((tu) => tu.permissions.indexOf('print_qr_codes') !== -1) != null
  },
  canRunReports (user) {
    return user.team_users.find((tu) => tu.permissions.indexOf('run_reports') !== -1) != null
  },
  canViewInbox (user, team) {
    return user.team_users.find((tu) => tu.team.id === team.id && tu.permissions.indexOf('view_inbox') !== -1) != null
  }
}



// WEBPACK FOOTER //
// ./src/lib/permissions.js